module.exports = __webpack_public_path__ + "img/user.1c260796.svg";